import { asAbortable } from './asAbortable';
export class TimeoutError extends Error {
    code = 'TimeoutError';
    constructor(timeoutInMs, customErrorContext) {
        super(customErrorContext === undefined
            ? `timed out after ${timeoutInMs} ms`
            : `${customErrorContext} (timed out after ${timeoutInMs} ms)`);
    }
}
export const withTimeout = (task, timeoutInMs, customErrorContext, abortSignal) => {
    let timeoutRef;
    return asAbortable(Promise.race([
        task,
        new Promise((_resolve, reject) => {
            timeoutRef = setTimeout(() => {
                reject(new TimeoutError(timeoutInMs, customErrorContext));
            }, timeoutInMs);
        })
    ]), abortSignal, customErrorContext).finally(() => {
        clearTimeout(timeoutRef);
    });
};
//# sourceMappingURL=withTimeout.js.map